module.exports = __webpack_public_path__ + "img/hr-red-asterisk-13.953c8367.png";